/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type PostApiCampaignsBodyContentContentType =
    (typeof PostApiCampaignsBodyContentContentType)[keyof typeof PostApiCampaignsBodyContentContentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostApiCampaignsBodyContentContentType = {
    SMS: 'SMS',
    EMAIL: 'EMAIL',
} as const;
